<template>
  <v-row no-gutters>
    <v-btn class="d-flex justify-space-around std-btn-back std-text-white-1"
           :style="{backgroundColor: color + ' !important'}"
           block
           color="#FF006A"
           height="40px"
           depressed>
      <div class="d-flex justify-space-between align-center">
        {{text}}
      </div>
    </v-btn>
  </v-row>
</template>

<script>
    export default {
        name: "WarnButton",
        props: {
            text: {
                type: String
            },
            color: {
                type: String
            },
          disabled: {
            type: Boolean,
            default: false,
          }
        }
    }
</script>

<style scoped>


</style>